import React, { useCallback, useMemo } from "react";
import { Comment, Email } from "../../../cores/contacts/interfaces/api/get-contact";
import CommentCard from "./CommentCard";
import CommentInput from "./CommentInput";
import _ from "lodash";
import EmailCard from "./EmailCard";

interface Props {
  comments: Comment[];
  emails: Email[];
  onSubmit: (arg0: string, arg1: number) => void;
}

export default function ActivityContainer(props: Props) {
  const { comments, emails, onSubmit } = props;

  const activitiesFiltered = useMemo(() => {
    const com = comments.map((comment) => ({ ...comment, object: "comment" }));
    const ema = emails.map((email) => ({ ...email, object: "email" }));
    const details = [...com, ...ema]

    return _.orderBy(details, "createdAt", "desc");
  }, [emails, comments]);

  const showActivity = useCallback((activity) => {
    switch(activity.object) {
      case "comment":
        return <CommentCard 
          key={activity.id}
          comment={activity as Comment}
        />
      case "email":
        return <EmailCard key={activity.id} email={activity as Email} />
    }
  }, []);

  return (
    <div className="py-2">
      <div className="w-100">
        <CommentInput onSubmit={onSubmit} />
        {activitiesFiltered.map((activity) => (
          showActivity(activity)
        ))}
      </div>
    </div>
  );
}
